module.exports = __webpack_public_path__ + "static/desktop/img/production-mobile-diarybook.32be3a09.png";